import { Component } from 'react';
import _ from 'lodash';

export default class FormComponent extends Component {
	constructor(props) {
		super(props);

		this.requiredPathMap = {};
		this.state = {
			formFieldError: {},
		};
	}

	setForm = (path, label, isRequired, defaultValue) => {
		if (isRequired) {
			this.requiredPathMap[path] = { path, label };
		}
		return {
			key: path,
			path,
			label,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};
}
